export default {
  SET_PROFILE(state, payload) {
    state.profile = payload;
  },
  SET_PROFILE_LOADING(state, loading) {
    state.loading = loading;
  },
};
